import { DefaultState } from '@src/redux/types'

import {
  FEEDBACK_ALL,
  FEEDBACK_CREATE,
  FEEDBACK_EDIT,
  FEEDBACK_FORM,
  FEEDBACK_FORM_ALL,
  FEEDBACK_FORM_CREATE,
  FEEDBACK_FORM_DELETE,
  FEEDBACK_FORM_LIST,
  FEEDBACK_LIST,
  FEEDBACK_TYPES,
  FEEDBACK_UPDATE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [FEEDBACK_EDIT]: DefaultState<`${typeof API.FEEDBACK_EDIT}`, 'get'>
  [FEEDBACK_ALL]: DefaultState<`${typeof API.FEEDBACK_ALL}`, 'get'>
  [FEEDBACK_LIST]: DefaultState<`${typeof API.FEEDBACK}`, 'get'>
  [FEEDBACK_CREATE]: DefaultState<`${typeof API.FEEDBACK}`, 'post'>
  [FEEDBACK_UPDATE]: DefaultState<`${typeof API.FEEDBACK_UPDATE}`, 'put'>
  [FEEDBACK_TYPES]: DefaultState<`${typeof API.FEEDBACK_TYPES}`, 'get'>
  [FEEDBACK_FORM]: DefaultState<`${typeof API.FEEDBACK_FORM}{id}`, 'get'>
  [FEEDBACK_FORM_ALL]: DefaultState<`${typeof API.FEEDBACK_FORM_ALL}`, 'get'>
  [FEEDBACK_FORM_LIST]: DefaultState<`${typeof API.FEEDBACK_FORM}`, 'get'>
  [FEEDBACK_FORM_CREATE]: DefaultState<`${typeof API.FEEDBACK_FORM}`, 'post'>
  [FEEDBACK_FORM_DELETE]: DefaultState<`${typeof API.FEEDBACK_FORM}{id}`, 'delete'>
} = () => ({
  [FEEDBACK_EDIT]: defaultState(),
  [FEEDBACK_ALL]: defaultState(),
  [FEEDBACK_LIST]: defaultState(),
  [FEEDBACK_CREATE]: defaultState(),
  [FEEDBACK_UPDATE]: defaultState(),
  [FEEDBACK_TYPES]: defaultState(),
  [FEEDBACK_FORM]: defaultState(),
  [FEEDBACK_FORM_ALL]: defaultState(),
  [FEEDBACK_FORM_LIST]: defaultState(),
  [FEEDBACK_FORM_CREATE]: defaultState(),
  [FEEDBACK_FORM_DELETE]: defaultState(),
})
